import { render } from "./CreateSafetyPlan.vue?vue&type=template&id=15c20fb0"
import script from "./CreateSafetyPlan.vue?vue&type=script&lang=js"
export * from "./CreateSafetyPlan.vue?vue&type=script&lang=js"

import "./CreateSafetyPlan.vue?vue&type=style&index=0&id=15c20fb0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__